"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Body = require("../Body");
var _Image360PreviewItem = require("../Body/ItemList/Image360PreviewItem");
var _ImagePreviewItem = require("../Body/ItemList/ImagePreviewItem");
var _VideoPreviewItem = require("../Body/ItemList/VideoPreviewItem");
const PreviewBody = _ref => {
  let {
    isPreview = true,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Body.Body, (0, _extends2.default)({
    isPreview: isPreview,
    Image360ItemComponent: _Image360PreviewItem.Image360PreviewItem,
    ImageItemComponent: _ImagePreviewItem.ImagePreviewItem,
    VideoItemComponent: _VideoPreviewItem.VideoPreviewItem
  }, rest));
};
exports.PreviewBody = PreviewBody;
//# sourceMappingURL=PreviewBody.js.map